// Custom hook for ForgotPassword page logic
import { useState } from 'react';
import { Form } from 'antd';
import { z } from 'zod';
import { useMessage } from '@context/MessageProvider';
import { forgotPasswordSchema } from '@validators/outside.schema';
import { useRequestPasswordResetMutation } from './useAuthMutations';

export const useForgotPassword = () => {
    const [form] = Form.useForm();
    const { showMessage } = useMessage();
    const [submitted, setSubmitted] = useState(false);
    const resetMutation = useRequestPasswordResetMutation();

    const onFinish = async (values) => {
        try {
            const parsedValues = forgotPasswordSchema.parse(values);
            await resetMutation.mutateAsync(parsedValues.email);
            setSubmitted(true);
        } catch (error) {
            if (error instanceof z.ZodError) {
                form.setFields([
                    {
                        name: 'email',
                        errors: [error.errors[0].message]
                    }
                ]);
            }
        }
    };

    return {
        form,
        loading: resetMutation.isPending,
        submitted,
        onFinish
    };
};

